import { render, staticRenderFns } from "./aboutCenNav.vue?vue&type=template&id=09a8fa68&scoped=true"
import script from "./aboutCenNav.vue?vue&type=script&lang=js"
export * from "./aboutCenNav.vue?vue&type=script&lang=js"
import style1 from "./aboutCenNav.vue?vue&type=style&index=1&id=09a8fa68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a8fa68",
  null
  
)

export default component.exports